// extracted by mini-css-extract-plugin
export default {"link":"styles_link__G59iY","linkIcon":"styles_linkIcon__p6KnW"};